module.exports = __webpack_public_path__ + "img/logo-1.bb84853c.png";